import { Link } from "react-router-dom";

const FEATURES = [
  {
    icon: "ri-camera-lens-line",
    title: "真实记录",
    desc: "不摆拍、不刻意，把最日常的画面原样呈现给你。",
  },
  {
    icon: "ri-compass-3-line",
    title: "多样视角",
    desc: "从菜市场到山海之间，用镜头带你看不一样的生活切面。",
  },
  {
    icon: "ri-heart-2-line",
    title: "用心分享",
    desc: "每条视频背后都是一段真实经历，值得被认真对待。",
  },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-secondary-100/70">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-8 md:py-20">
        <div className="grid gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-background-50 px-3 py-1 text-xs font-medium text-secondary-700">
              <i className="ri-heart-3-line" /> 关于糖心Vlog
            </span>
            <h2 className="mt-4 font-heading text-2xl font-extrabold leading-tight text-foreground-950 md:text-4xl">
              我们相信，平凡的日子
              <br />
              也值得被认真记录
            </h2>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-foreground-700 md:text-base">
              糖心Vlog 是一个个人视频博客。这里没有精致的剧本，只有真实发生的生活：
              清晨的咖啡、旅途中的雨、深夜的一点想法。希望你能在这里，找到属于自己的那份共鸣与放松。
            </p>
            <Link
              to="/about"
              className="mt-7 inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解站长的故事 <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="flex flex-col gap-4">
            {FEATURES.map((f) => (
              <div
                key={f.title}
                className="flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-xl text-primary-600">
                  <i className={f.icon} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{f.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}